import {TLangForm} from "../types";

export const LOCALE_KEY = 'LOCALE_WTG'

export const EmptyTranslateForm: TLangForm = { en: '', uk: '', es: '' }